<app-sub-menu [subMenus]="subMenus"></app-sub-menu>

<div class="container-fluid bg-box">
  <button
    class="btn btn-sm btn-success mb-2 text-uppercase"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#collapseExample"
    aria-expanded="false"
    aria-controls="collapseExample"
    [disabled]="disableBtnFiltros"
  >
    <i class="fa fa-search"></i>
    Buscar revisión
  </button>
  <div class="collapse" id="collapseExample">
    <div class="card card-body">
      <app-form-cartera-revisones
        [negocioUsuario]="negocioUsuario"
        [etapas]="etapas"
        [tipoRevisiones]="tipoRevisiones"
        (emitSearch)="searchRevisionChild($event)"
      />
    </div>
  </div>
</div>

<div class="container-fluid bg-box">
  <div class="row">
    <div class="col">
      <h3>Resultado de la búsqueda</h3>
    </div>
    <div class="col text-right">
      <button
        *ngIf="revisiones?.length > 0"
        (click)="export()"
        class="btn btn-sm btn-success"
      >
        <i class="fas fa-file-excel"></i> Exportar
      </button>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div class="table-responsive">
        <table
          id="tableCarteraRevision"
          datatable="ng"
          class="table table-bordered table-hover"
          [class.table-striped]="revisiones"
        >
          <thead>
            <tr>
              <th scope="col">Estatus</th>
              <th scope="col">Folio</th>
              <th scope="col">Nombre</th>
              <th scope="col">Estación</th>
              <th scope="col">Tipo de revisión</th>
              <th scope="col">Fecha inicio plan</th>
              <th scope="col">Fecha fin plan</th>
              <th scope="col">Fecha inicio real</th>
              <th scope="col">Fecha fin real</th>
              <th scope="col">Fecha ultima sincronización</th>
              <th scope="col">Calificación</th>
              <th scope="col">Checklist</th>
            </tr>
          </thead>
          <tbody
            *ngIf="revisiones; else loading"
s          >
            <tr *ngFor="let revision of revisiones">
              <td>
                <div class="badges">
                  <span
                    [ngStyle]="{ 'background-color': revision.Etapa.Color }"
                    class="badges--publicado"
                  >
                    {{ revision.Etapa.Descripcion }}
                  </span>
                </div>
              </td>
              <td>{{ revision.IdRevision }}</td>
              <td>{{ revision.Descripcion }}</td>
              <td>{{ revision.Estacion.Nombre }}</td>
              <td>{{ revision.TipoRevision.Descripcion }}</td>
              <td>{{ datetimeToDateFormat(revision.FechaInicioPlan) }}</td>
              <td>{{ datetimeToDateFormat(revision.FechaFinPlan) }}</td>
              <td>
                {{ datetimeToDateFormat(revision.FechaInicioReal, true) }}
              </td>
              <td>{{ datetimeToDateFormat(revision.FechaFinReal, true) }}</td>
              <td>{{ datetimeToDateFormat(revision.FechaSync, true) }}</td>
              <td>{{ revision.Calificacion }}</td>
              <td style="text-align: center">
                <button
                  type="button"
                  class="btn btn-primary primary btn-sm rounded-circle"
                  (click)="checklistClick(revision.IdRevision)"
                >
                  <i class="fa fa-list"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!loadRows">
              <td colspan="12" class="text-center">
                <button
                  class="btn btn-lg btn-outline-dark text-uppercase w-100"
                  (click)="loadCarteraRevisiones()"
                >
                  Cargar mas revisiones
                </button>
              </td>
            </tr>
            <tr *ngIf="loadRows">
              <td colspan="12" class="text-center">
                <p>CARGANDO...</p>
              </td>
            </tr>
          </tbody>
          <ng-template #loading>
            <tbody>
              <tr *ngFor="let item of [].constructor(6)">
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
                <td colspan="4">
                  <div
                    class="w-100 p-3 rounded border border-white skeleton"
                  ></div>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </div>
  </div>
</div>
